import { formatStreetAddress } from 'components/marketplace/helpers';

import { COSMOS_URL } from '../../globals';
import { FALLBACK_URL } from '../components/CoverImages';

function getHumanReadableAddress(
  street?: string | null,
  unitType?: string | null,
  unitNumber?: string | null,
  city?: string | null,
  state?: string | null,
  postalCode?: string | null,
) {
  const formattedStreet = formatStreetAddress(street, unitType, unitNumber);
  if (!formattedStreet || !city || !state || !postalCode) {
    return '';
  }
  return `${formattedStreet}, ${city}, ${state} ${postalCode}`;
}

const getReadableListingStatus = (listingState: string | null | undefined) => {
  if (!listingState) {
    return 'Unknown';
  }
  if (listingState === 'SELL_REQUEST_TEMP_OFF_MARKET') {
    return 'Off Market';
  }
  return listingState
    .substring('SELL_REQUEST_'.length)
    .split('_')
    .map((input) => input.charAt(0).toUpperCase() + input.slice(1).toLowerCase())
    .join(' ');
};

export const getSeoFields = (
  addressId: string | undefined,
  displaySlug: string | null | undefined,
  status: string | null | undefined,
  street: string | undefined | null,
  unitType: string | undefined | null,
  unitNumber: string | undefined | null,
  city: string | undefined | null,
  state: string | undefined | null,
  postalCode: string | undefined | null,
  sqFtLot: number | null | undefined,
  bedrooms: number | null | undefined,
  bathrooms: number | null | undefined,
  yearBuilt: string | number | null | undefined,
  coverImageProp: string | null | undefined,
) => {
  const readableAddress = getHumanReadableAddress(
    street,
    unitType,
    unitNumber,
    city,
    state,
    postalCode,
  );
  const title = `Home for sale - ${readableAddress} | Opendoor`;
  const canonicalUrl = displaySlug
    ? `${COSMOS_URL}/properties/${displaySlug}/aid_${addressId}`
    : `${COSMOS_URL}/properties/${street ? `${street?.toLowerCase()?.replaceAll(' ', '-')}-` : ''}${
        unitNumber ? `${unitNumber}-` : ''
      }${
        city ? `${city?.toLowerCase()}-` : ''
      }-${state?.toLowerCase()}${postalCode}/aid_${addressId}`;
  const forSale = getReadableListingStatus(status) === 'Active';
  const metaDescription = `${readableAddress} is currently ${
    forSale ? 'for sale' : 'not for sale'
  }. The ${sqFtLot ? `${sqFtLot} sq ft.` : ''} home ${
    yearBuilt ? `was built in ${yearBuilt}` : ''
  } ${bedrooms ? `and has ${bedrooms} bedrooms` : ''} ${
    bathrooms ? `and has ${bathrooms} bathrooms` : ''
  }. Learn more about the home on Opendoor.`;
  let coverImage = FALLBACK_URL;
  if (coverImageProp) {
    // Use a larger preset so link previews (iMessage/SMS, Facebook, Twitter, WhatsApp)
    // render a high-quality hero image rather than a tiny thumbnail.
    coverImage = `${coverImageProp}?${new URLSearchParams({
      preset: '3:2-lg',
      service: 'cosmos',
    }).toString()}`;
  }
  return { readableAddress, canonicalUrl, metaDescription, title, coverImage };
};
